(function () {
    const termsCopy = {
        en: {
            before: 'I accept the ',
            link: 'terms of service',
            after: '.'
        },
        hr: {
            before: 'Prihvaćam ',
            link: 'uvjete korištenja',
            after: '.'
        },
        bs: {
            before: 'Prihvatam ',
            link: 'uslove korištenja',
            after: '.'
        },
        sr: {
            before: 'Прихватам ',
            link: 'услове коришћења',
            after: '.'
        },
        sl: {
            before: 'Sprejemam ',
            link: 'pogoje uporabe',
            after: '.'
        },
        de: {
            before: 'Ich akzeptiere die ',
            link: 'Nutzungsbedingungen',
            after: '.'
        },
        fr: {
            before: "J'accepte les ",
            link: "conditions d'utilisation",
            after: '.'
        },
        es: {
            before: 'Acepto los ',
            link: 'términos del servicio',
            after: '.'
        },
        it: {
            before: 'Accetto i ',
            link: 'termini di servizio',
            after: '.'
        }
    };

    const getLanguage = () => {
        const language = window.ShopifyCurrentLanguage || (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';

        return language.toLowerCase().split('-')[0];
    };

    const getCopy = () => termsCopy[getLanguage()] || termsCopy.en;

    const getCopyText = (copy) => `${copy.before}${copy.link}${copy.after}`;

    const getTermsHref = (block) => {
        const link = block.querySelector('a[href]');

        return link ? link.getAttribute('href') : '/policies/terms-of-service';
    };

    const syncAppMetafield = () => {
        if (!window.rterms || !window.rterms.metafield) {
            return;
        }

        const copy = getCopy();
        const metafieldText = `${copy.before}<a target="_blank" href="/policies/terms-of-service">${copy.link}</a>${copy.after}`;

        if (window.rterms.metafield.text !== metafieldText) {
            window.rterms.metafield.text = metafieldText;
        }
    };

    const localizeLabel = (block) => {
        const input = block.querySelector('.rterms-checkbox');
        const label = block.querySelector('label');

        if (!input || !label) {
            return;
        }

        if (!input.id) {
            input.id = `rterms-${Math.random().toString(36).slice(2, 9)}`;
        }

        const copy = getCopy();
        const language = getLanguage();
        const termsHref = getTermsHref(block);
        const desiredText = getCopyText(copy);
        const currentLink = label.querySelector('a[href]');

        if (
            label.getAttribute('for') === input.id &&
            block.dataset.jeordiesTermsLanguage === language &&
            label.textContent.trim() === desiredText &&
            currentLink &&
            currentLink.getAttribute('href') === termsHref
        ) {
            return;
        }

        const link = document.createElement('a');

        label.setAttribute('for', input.id);
        label.textContent = '';

        link.href = termsHref;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = copy.link;

        label.append(document.createTextNode(copy.before), link, document.createTextNode(copy.after));
        block.setAttribute('data-jeordies-cart-terms', 'localized');
        block.dataset.jeordiesTermsLanguage = language;
    };

    const moveDrawerTerms = (block) => {
        const drawer = block.closest('.cart-drawer');

        if (!drawer) {
            return;
        }

        const subtotalBlock = drawer.querySelector('.cart-footer__subtotal-block');

        if (subtotalBlock && block.parentElement !== subtotalBlock) {
            subtotalBlock.appendChild(block);
        }
    };

    const moveCartTemplateTerms = (block) => {
        const cartTemplate = block.closest('.cart-template');

        if (!cartTemplate || block.closest('.cart-drawer') || block.closest('.cart-notification')) {
            return;
        }

        const ctas = cartTemplate.querySelector('.cart-template__ctas');

        if (!ctas) {
            return;
        }

        if (block.parentElement !== ctas || block.nextElementSibling) {
            ctas.appendChild(block);
        }
    };

    const getCartTemplate = () => document.querySelector('.cart-template:not(.is-empty)');

    const getDeliveryModule = () => {
        const cartTemplate = getCartTemplate();

        return cartTemplate ? cartTemplate.querySelector('#parcelshopMainContainer') : null;
    };

    const getCartTemplateTerms = () => {
        const cartTemplate = getCartTemplate();

        return cartTemplate ? cartTemplate.querySelector('.terms-relentless') : null;
    };

    const getCartDrawer = () => document.querySelector('.cart-drawer:not(.is-empty)');

    const getVisibleCartDrawer = () => {
        const drawers = Array.from(document.querySelectorAll('.cart-drawer:not(.is-empty)'));

        return drawers.find((drawer) => {
            return drawer.classList.contains('is-active') ||
                drawer.getAttribute('aria-hidden') === 'false' ||
                drawer.offsetParent !== null;
        }) || drawers[0] || null;
    };

    const getCartDrawerTerms = (cartDrawer = getCartDrawer()) => {
        return cartDrawer ? cartDrawer.querySelector('.terms-relentless') : null;
    };

    const getAdditionalCheckout = () => {
        const cartTemplate = getCartTemplate();

        return cartTemplate ? cartTemplate.querySelector('.cart-footer__ctas-additional') : null;
    };

    const hasSelectedDelivery = () => {
        const deliveryModule = getDeliveryModule();

        if (!deliveryModule) {
            return true;
        }

        return Boolean(
            deliveryModule.querySelector(
                '#homeDeliveryCheckBox.shippingMethodChecked, #parcelShopCheckBox.shippingMethodChecked, #personalCollectionCheckBox.shippingMethodChecked'
            )
        );
    };

    const hasAcceptedTerms = () => {
        const termsBlock = getCartTemplateTerms();
        const input = termsBlock ? termsBlock.querySelector('.rterms-checkbox') : null;

        return !input || input.checked;
    };

    const hasAcceptedDrawerTerms = (cartDrawer) => {
        const termsBlock = getCartDrawerTerms(cartDrawer);
        const input = termsBlock ? termsBlock.querySelector('.rterms-checkbox') : null;

        return !input || input.checked;
    };

    const syncAdditionalCheckoutState = () => {
        const additionalCheckout = getAdditionalCheckout();

        if (!additionalCheckout) {
            return;
        }

        const isReady = hasSelectedDelivery() && hasAcceptedTerms();
        const shouldDisable = !isReady;

        if (additionalCheckout.classList.contains('jeordies-additional-checkout-disabled') !== shouldDisable) {
            additionalCheckout.classList.toggle('jeordies-additional-checkout-disabled', shouldDisable);
        }

        if (additionalCheckout.getAttribute('aria-disabled') !== String(shouldDisable)) {
            additionalCheckout.setAttribute('aria-disabled', String(shouldDisable));
        }
    };

    const setValidationMessage = (container, key, visible) => {
        if (!container) return;
        let message = container.querySelector('[data-cart-validation="' + key + '"]');
        if (!message && visible) {
            message = document.createElement('p');
            message.dataset.cartValidation = key;
            message.setAttribute('role', 'alert');
            message.style.cssText = 'color:#b00020;font-size:13px;margin:12px 0;';
            container.appendChild(message);
        }
        if (message) {
            message.textContent = document.documentElement.dataset[key] || '';
            message.hidden = !visible;
        }
    };

    const showDeliveryError = () => {
        const deliveryModule = getDeliveryModule();

        if (!deliveryModule) {
            return;
        }

        deliveryModule.classList.add('jeordies-delivery-error');
        setValidationMessage(deliveryModule, 'deliveryError', true);
        deliveryModule.querySelector('#parcelShopModuleHeader')?.setAttribute('aria-invalid', 'true');
    };

    const clearDeliveryError = () => {
        const deliveryModule = getDeliveryModule();

        if (!deliveryModule) {
            return;
        }

        deliveryModule.classList.remove('jeordies-delivery-error');
        setValidationMessage(deliveryModule, 'deliveryError', false);
        deliveryModule.querySelector('#parcelShopModuleHeader')?.removeAttribute('aria-invalid');
    };

    const showTermsError = () => {
        const termsBlock = getCartTemplateTerms();
        const input = termsBlock ? termsBlock.querySelector('.rterms-checkbox') : null;

        if (!termsBlock) {
            return;
        }

        termsBlock.classList.add('jeordies-terms-error');
        setValidationMessage(termsBlock, 'termsError', true);
        input?.setAttribute('aria-invalid', 'true');
    };

    const clearTermsError = () => {
        const termsBlock = getCartTemplateTerms();
        const input = termsBlock ? termsBlock.querySelector('.rterms-checkbox') : null;

        if (!termsBlock) {
            return;
        }

        termsBlock.classList.remove('jeordies-terms-error');
        setValidationMessage(termsBlock, 'termsError', false);
        input?.removeAttribute('aria-invalid');
    };

    const showDrawerTermsError = (cartDrawer = getVisibleCartDrawer()) => {
        const termsBlock = getCartDrawerTerms(cartDrawer);
        const input = termsBlock ? termsBlock.querySelector('.rterms-checkbox') : null;

        if (!termsBlock) {
            return;
        }

        termsBlock.classList.add('jeordies-terms-error');
        setValidationMessage(termsBlock, 'termsError', true);
        input?.setAttribute('aria-invalid', 'true');
    };

    const clearDrawerTermsError = (cartDrawer = getVisibleCartDrawer()) => {
        const termsBlock = getCartDrawerTerms(cartDrawer);
        const input = termsBlock ? termsBlock.querySelector('.rterms-checkbox') : null;

        if (!termsBlock) {
            return;
        }

        termsBlock.classList.remove('jeordies-terms-error');
        setValidationMessage(termsBlock, 'termsError', false);
        input?.removeAttribute('aria-invalid');
    };

    const scrollToCartError = (deliveryMissing, termsMissing) => {
        const target = deliveryMissing ? getDeliveryModule() : (termsMissing ? getCartTemplateTerms() : null);

        target?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    };

    const validateCartTemplate = (shouldScroll = false) => {
        updateTerms();

        const deliveryMissing = !hasSelectedDelivery();
        const termsMissing = !hasAcceptedTerms();

        if (deliveryMissing) {
            showDeliveryError();
        } else {
            clearDeliveryError();
        }

        if (termsMissing) {
            showTermsError();
        } else {
            clearTermsError();
        }

        if (shouldScroll && (deliveryMissing || termsMissing)) {
            scrollToCartError(deliveryMissing, termsMissing);
        }

        syncAdditionalCheckoutState();

        return !deliveryMissing && !termsMissing;
    };

    const validateCartDrawer = (cartDrawer = getVisibleCartDrawer(), shouldScroll = false) => {
        updateTerms();

        const termsMissing = !hasAcceptedDrawerTerms(cartDrawer);

        if (termsMissing) {
            showDrawerTermsError(cartDrawer);
        } else {
            clearDrawerTermsError(cartDrawer);
        }

        if (shouldScroll && termsMissing) {
            getCartDrawerTerms(cartDrawer)?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }

        return !termsMissing;
    };

    const handleCartTemplateSubmit = (event) => {
        const drawerForm = event.target.matches('.cart-drawer .cart-items__form') ? event.target : null;

        if (drawerForm && event.submitter?.matches('.cart-footer__button[name="checkout"]') && !validateCartDrawer(drawerForm.closest('.cart-drawer'), true)) {
            event.preventDefault();
            event.stopImmediatePropagation();

            return;
        }

        if (!event.target.matches('.cart-template .cart-items__form')) {
            return;
        }

        if (!validateCartTemplate(true)) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    };

    const handleCartTemplateClick = (event) => {
        const checkoutButton = event.target.closest('.cart-template__ctas .cart-footer__button[name="checkout"]');
        const additionalCheckout = event.target.closest('.cart-template .cart-footer__ctas-additional');
        const drawerCheckoutButton = event.target.closest('.cart-drawer .cart-footer__button[name="checkout"]');

        if (drawerCheckoutButton && !validateCartDrawer(drawerCheckoutButton.closest('.cart-drawer'), true)) {
            event.preventDefault();
            event.stopImmediatePropagation();

            return;
        }

        if (checkoutButton && !validateCartTemplate(true)) {
            event.preventDefault();
            event.stopImmediatePropagation();

            return;
        }

        if (additionalCheckout && !validateCartTemplate(true)) {
            event.preventDefault();
            event.stopImmediatePropagation();

            return;
        }

        if (event.target.closest('#homeDeliveryCheckBox, #parcelShopCheckBox, #personalCollectionCheckBox')) {
            window.setTimeout(() => {
                if (hasSelectedDelivery()) {
                    clearDeliveryError();
                }

                syncAdditionalCheckoutState();
            }, 0);
        }
    };

    const handleCartTemplateChange = (event) => {
        if (event.target.matches('.cart-template .rterms-checkbox') && event.target.checked) {
            clearTermsError();
        }

        if (event.target.matches('.cart-drawer .rterms-checkbox') && event.target.checked) {
            clearDrawerTermsError(event.target.closest('.cart-drawer'));
        }

        if (
            event.target.matches('.cart-template .rterms-checkbox') ||
            event.target.closest('#homeDeliveryCheckBox, #parcelShopCheckBox, #personalCollectionCheckBox')
        ) {
            window.setTimeout(syncAdditionalCheckoutState, 0);
        }
    };

    const installAlertGuard = () => {
        if (window.jeordiesCartAlertGuardInstalled) {
            return;
        }

        window.jeordiesCartAlertGuardInstalled = true;
        window.jeordiesOriginalAlert = window.alert;

        window.alert = function (message) {
            const normalizedMessage = String(message || '').toLowerCase();
            const isDeliveryAlert = normalizedMessage.includes('način dostave') || normalizedMessage.includes('nacin dostave');
            const isTermsAlert = normalizedMessage.includes('terms of service') || normalizedMessage.includes('uvjete korištenja') || normalizedMessage.includes('uvjete koristenja');

            if (isDeliveryAlert || isTermsAlert) {
                if (isDeliveryAlert) {
                    showDeliveryError();
                }

                if (isTermsAlert) {
                    showTermsError();
                    showDrawerTermsError();
                }

                scrollToCartError(isDeliveryAlert, isTermsAlert);

                return;
            }

            window.jeordiesOriginalAlert.apply(window, arguments);
        };
    };

    const updateTerms = () => {
        syncAppMetafield();

        document.querySelectorAll('.terms-relentless').forEach((block) => {
            localizeLabel(block);
            moveDrawerTerms(block);
            moveCartTemplateTerms(block);
        });

        syncAdditionalCheckoutState();
    };

    let updateQueued = false;

    const scheduleUpdate = () => {
        if (updateQueued) {
            return;
        }

        updateQueued = true;

        window.requestAnimationFrame(() => {
            updateQueued = false;
            updateTerms();
        });
    };

    installAlertGuard();

    document.addEventListener('submit', handleCartTemplateSubmit, true);
    document.addEventListener('click', handleCartTemplateClick, true);
    document.addEventListener('change', handleCartTemplateChange, true);
    document.addEventListener('DOMContentLoaded', updateTerms);
    document.addEventListener('shopify:section:load', updateTerms);
    document.addEventListener('cart:refresh', scheduleUpdate);
    document.addEventListener('cart:updated', scheduleUpdate);

    if (window.themeCore && window.themeCore.EventBus) {
        window.themeCore.EventBus.listen('cart:drawer:open', scheduleUpdate);
        window.themeCore.EventBus.listen('cart:drawer:CartDrawer:open', scheduleUpdate);
        window.themeCore.EventBus.listen('cart:updated', scheduleUpdate);
    }

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();
